export const API_ENDPOINTS = {
  getStatus: (paymentRequestId: string) =>
    `/checkout/${paymentRequestId}/status`,
  getBanks: (customerId: string, country: string, currency: string) =>
    `/checkout/banks/${customerId}/${country}/${currency}`,
  patchBank: (paymentRequestId: string) => `/checkout/${paymentRequestId}/bank`,
  process: (paymentId: string, paymentHash: string) =>
    `/checkout/${paymentId}/process?hash=${paymentHash}`,
  redirectProxy: (paymentId: string) => `/redirect/${paymentId}`,
  redeemPayment: () => `/checkout/redeem`,
  cancelPayment: (paymentId: string) =>
    `/payments/${window.btoa(paymentId)}/cancel`,
  processPlaidEvent: (paymentId: string, eventType: string) =>
    `/payment-process/${paymentId}/plaid/${eventType}`,
  initializePasskeyRegistration: () =>
    '/checkout/passkey/registration/initialize',
  finalizePasskeyRegistration: () => '/checkout/passkey/registration/finalize',
  initializePasskeyLogin: () => '/checkout/passkey/login/initialize',
  finalizePasskeyLogin: () => '/checkout/passkey/login/finalize',
} as const;
